import React from 'react';
import "./LocationPage.css";
import LocationListHeader from '../../components/LocationListHeader';
import ManagedDeviceList from 'components/ManagedDeviceList';
import { useAuth } from "context/AuthContext";
import { ITEM_NUM_PER_PAGE_LOCATION } from 'constants/config';
import { LOCATION_LIST } from './constants';

const propTypes = {};
const defaultProps = {};
const LocationPage = (props) => {
  /*** States and Variables ***/
  const [keyword, setKeyword] = React.useState('');
  const { currentUser } = useAuth();

  /*** Event Handlers ***/
  const onSearch = (originalKeyword, keywords) => {
    setKeyword(originalKeyword);
  }

  /*** Main Render ***/
  return <div className='location_page_container'>
    <LocationListHeader
      keyword={keyword}
      onSearch={onSearch}
      selected={LOCATION_LIST}
    />
    <ManagedDeviceList keyword={keyword} type="LOCATION" currentUser={currentUser} itemNumPerPage={ITEM_NUM_PER_PAGE_LOCATION} />
  </div>;
}
LocationPage.propTypes = propTypes;
LocationPage.defaultProps = defaultProps;
export default LocationPage;
